import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

// A small searchable list modal for choosing the one item a time entry is linked to (a task, missing info, to do
// or appointment). Dismisses with the chosen item, or null.
@Component({
  selector: 'app-link-picker',
  templateUrl: './link-picker.component.html',
})
export class LinkPickerComponent {
  @Input() title = 'Select';
  @Input() items: { guid: string, title: string, subtitle?: string }[] = [];
  @Input() empty_message = 'Nothing to select.';

  search = '';

  constructor(private modalController: ModalController) { }

  get filtered_items() {
    const q = (this.search || '').trim().toLowerCase();
    if (!q) return this.items;
    return this.items.filter(i => (i.title || '').toLowerCase().includes(q) || (i.subtitle || '').toLowerCase().includes(q));
  }

  Select(item: any) {
    this.modalController.dismiss(item);
  }

  Close() {
    this.modalController.dismiss(null);
  }
}
